/**
 * Created by Qingger Corp.
 * User: yangzihua
 * Date: 2019/6/10
 * Time: 17:45
 * Desc: 虚拟店长管理-虚拟店长信息-提现历史
 */

import { Component, Prop, Vue } from 'vue-property-decorator';
import moment from 'moment';
import { IPSService } from '@/services/ipsServices';
import { Functions } from '@/library/utils/functions';
import { appEnvConfig } from '@/configs/appConfigs';
import ExportFile from '@/views/components/exportFile';
import { parseSec } from '@/util';
@Component({
  components: {
    ExportFile,
  },
})
export default class WithdrawBoardHistory extends Vue {
  /* 数据 */

  /**
   * siteId
   * @type {number}
   */
  @Prop({ default: 0 }) siteId: number;
  @Prop() guiderId: number;

  @Prop({
    default() {
      return [];
    },
  })
    dater;

  /**
   * loading状态
   * @type {boolean}
   */
  public loadingState = false;

  /**
   * 提现历史列表
   * @type {Array<WithdrawBoardHistory>}
   */
  public withdrawList: Array<WithdrawBoardHistory> = [];

  /**
   * 页码
   * @type {number}
   */
  public page = 1;

  /**
   * 条数
   * @type {number}
   */
  public pageSize = 10;

  public keywords = '';

  /**
   * 总条数
   * @type {number}
   */
  public totalCount = 0;

  /**
   * 是否选中列表项
   * @type {boolean}
   */
  public isSelected = false;

  /**
   * 提现历史状态
   * @type {string}
   */
  public profitOutState = '';

  /**
   * 排序名称
   * @type {string}
   */
  public order = '';

  /**
   * 排序方式
   * @type {string}
   */
  public orderBy = '';

  public date = [];

  public defaultStart: Date | number;

  public defaultEnd: Date | number;

  /**
   *  导出按钮的信息
   * @type {ItemObject}
   */
  public exportBtnInfo: ItemObject = {
    state: 0,
    url: '',
  };

  /**
   * socket连接准备
   * @type {boolean}
   */
  public isSocketReady = false;

  /* 方法 */

  /**
   * 关键字搜索 (暂无)
   * @return null
   */
  public onSearchWithDrawHistory() {
    this.page = 1;
    this.pageSize = 10;
    this.getWithDrawList();
  }

  /**
   * 条数变更
   * @param {number} val
   * @return null
   */
  public onSizeChange(val: number): void {
    this.page = 1;
    this.pageSize = val;
    this.getWithDrawList();
  }

  /**
   * 页码变更
   * @return null
   */
  public onPageChange(val: number): void {
    this.page = val;
    this.getWithDrawList();
  }

  /**
   * 选中的活动
   * @param val
   * @return null
   */
  public onHandleSelectionChange(val): void {
    this.isSelected = val.length > 0;
  }

  ipsGetList(postParams) {
    IPSService.reportProfitOutList({ postParams }).then((res: ItemObject) => {
      this.totalCount = res.count;
      if (res && res.list && res.list.length > 0) {
        res.list.forEach((item) => {
          item.balance = Number(item.balance ? item.balance.toFixed(2) : 0);
          item.taxesBalance = item.taxesBalance ? item.taxesBalance.toFixed(2) : 0;
          item.outBalance = item.outBalance ? item.outBalance.toFixed(2) : 0;
          item.addTime = Functions.emptyVaribleHandler(item.addTime);
          item.siteName = Functions.emptyVaribleHandler(item.siteName);
          item.siteCode = Functions.emptyVaribleHandler(item.siteCode);
          item.reviewContent1 = Functions.emptyVaribleHandler(item.reviewContent1);
          item.reviewContent2 = Functions.emptyVaribleHandler(item.reviewContent2);
          item.reviewTime1 = Functions.emptyVaribleHandler(item.reviewTime1);
          item.reviewTime2 = Functions.emptyVaribleHandler(item.reviewTime2);
          item.reviewTime3 = Functions.emptyVaribleHandler(item.reviewTime3);
        });
      }
      this.withdrawList = res.list;
    });
  }

  /**
   * 获取提现历史列表
   * @return null
   */
  public getWithDrawList(): void {
    const postParams = {
      siteId: Number(this.siteId),
      page: this.page,
      pageSize: this.pageSize,
      keywords: this.keywords,
      order: this.order,
      orderBy: this.orderBy,
      profitOutState: this.profitOutState !== '' && this.profitOutState !== '9' ? Number.parseInt(this.profitOutState) : 9,
    };
    this.withdrawList = [];
    if (this.guiderId) {
      postParams['vGuiderId'] = +this.guiderId;
    }
    if (this.date && this.date.length) {
      const sTime = parseSec(5, this.date[0]) || '';
      const eTime = parseSec(6, this.date[1]) || '';
      postParams['startTime'] = moment(sTime).format('YYYY-MM-DD HH:mm:ss');
      postParams['endTime'] = moment(eTime).format('YYYY-MM-DD HH:mm:ss');
      if (this.date[1] - this.date[0] > 184 * 24 * 3600 * 1000) {
        this.$message.error('时间跨度不能超过6个月！');
        this.date = [this.defaultStart, this.defaultEnd];
        postParams['startTime'] = moment(this.date[0]).format('YYYY-MM-DD HH:mm:ss');
        postParams['endTime'] = moment(this.date[1]).format('YYYY-MM-DD HH:mm:ss');
        this.ipsGetList(postParams);
        return;
      }
    }
    this.ipsGetList(postParams);
  }

  /**
   * 选择佣金到账状态
   * @return null
   */
  public onProfitOutStateChange(): void {
    this.page = 1;
    this.pageSize = 10;
    this.getWithDrawList();
  }

  public dateChange() {
    this.page = 1;
    this.getWithDrawList();
  }

  /**
   * 列表排序
   * @param {ItemObject} column
   * @return null
   */
  public onSortChange(column: ItemObject): void {
    this.page = 1;
    this.pageSize = 10;
    this.order = column.prop;
    this.orderBy = column.order === 'ascending' ? 'ASC' : 'DESC';
    this.getWithDrawList();
  }

  get exportParams() {
    const postParams = {
      exportType: 'profitOut',
      params: {
        siteId: Number(this.siteId),
        keywords: this.keywords,
        order: this.order,
        orderBy: this.orderBy,
        profitOutState: this.profitOutState !== '' && this.profitOutState !== '9' ? Number.parseInt(this.profitOutState) : 9,
      },
    };
    if (this.guiderId) {
      postParams.params['vGuiderId'] = +this.guiderId;
    }
    if (this.date && this.date.length) {
      const sTime = parseSec(5, this.date[0]) || '';
      const eTime = parseSec(6, this.date[1]) || '';
      postParams.params['startTime'] = moment(sTime).format('YYYY-MM-DD HH:mm:ss');
      postParams.params['endTime'] = moment(eTime).format('YYYY-MM-DD HH:mm:ss');
    }
    return postParams;
  }

  created() {
    this.defaultStart = parseSec(3);
    this.defaultEnd = parseSec(4);
    if (this.dater && this.dater.length > 0) {
      this.date = [new Date(this.dater[0] * 1000), new Date(this.dater[1] * 1000)];
    }
    this.getWithDrawList();
  }
}
